export const sortOrderKeys = {
  alphaAsc: 'alphaAsc',
  alphaDesc: 'alphaDesc',
  newest: 'newest',
  popAsc: 'popAsc',
  priceLowHigh: 'priceLowHigh',
  priceHighLow: 'priceHighLow',
}

export const sortOrders = {
  [`${sortOrderKeys.alphaAsc}`]: {
    field: 'title',
    label: 'A-Z',
    order: 'asc',
  },
  [`${sortOrderKeys.alphaDesc}`]: {
    field: 'title',
    label: 'Z-A',
    order: 'desc',
  },
  [`${sortOrderKeys.newest}`]: {
    field: 'startDate',
    label: 'Newest',
    order: 'desc',
  },
  // The lower the popularity value,
  // the more popular the product is
  [`${sortOrderKeys.popAsc}`]: {
    field: 'popularity',
    label: 'Most Popular',
    order: 'asc',
  },
  [`${sortOrderKeys.priceLowHigh}`]: {
    field: 'advertisedPrice',
    label: 'Price (low to high)',
    order: 'asc',
  },
  [`${sortOrderKeys.priceHighLow}`]: {
    field: 'advertisedPrice',
    label: 'Price (high to low)',
    order: 'desc',
  },
}
